import common from '@/script/common.js';

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
   
    state: {
        dynamicPath: config.dynamicResourcePath
    },
    getters: {
        menus: state => {
            return common.cache("menus");
        },
    },
    mutations: {},
    actions: {}
})